// BL-2356 — registry entry for the offline reference read (PRJ-91, ADR 027 /
// ADR 062). Its own file so the parallel offline items' registry edits never
// collide; it may fold into one `offline` group once they have all landed.
import { responseType } from '@auctogon/core/api/registry';
import { defineAdminRoute } from './define-admin-route';
// Type-only import (erased at build) — keeps the registry client-bundle-safe.
import type { OfflineReferenceDto } from '../../schemas/responses/offline-reference';

export const offline_reference = {
  index: defineAdminRoute({
    path: '/api/tenants/:id/offline-reference',
    params: { id: '' },
    methods: {
      // The phone's poll for the lot form's option lists. The floor is the
      // offline delta's (BL-2339), so the sync engine is admitted or refused
      // by both reads alike. Each section is then narrowed by the grant its
      // online picker route declares — inside the service, read off those
      // routes' entries (access-grants.md § 6: a narrower check the
      // declaration can't express).
      GET: {
        grant: { anyOf: ['inventory.read', 'auction.read'] },
        tenant: { from: 'record', table: 'tenant', param: 'id' },
        response: responseType<OfflineReferenceDto>(),
      },
    },
  }),
};
